import { render, staticRenderFns } from "./ProfileBox.vue?vue&type=template&id=306681c4&scoped=true"
import script from "./ProfileBox.vue?vue&type=script&lang=js"
export * from "./ProfileBox.vue?vue&type=script&lang=js"
import style0 from "./ProfileBox.vue?vue&type=style&index=0&id=306681c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306681c4",
  null
  
)

export default component.exports